/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_Note_SubscriptionsInputs */

const en_why_listening_compare_note_subscriptions = /** @type {(inputs: Why_Listening_Compare_Note_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Often one app per device`)
};

const es_why_listening_compare_note_subscriptions = /** @type {(inputs: Why_Listening_Compare_Note_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A menudo una app por dispositivo`)
};

/**
* | output |
* | --- |
* | "Often one app per device" |
*
* @param {Why_Listening_Compare_Note_SubscriptionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_note_subscriptions = /** @type {((inputs?: Why_Listening_Compare_Note_SubscriptionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_Note_SubscriptionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_note_subscriptions(inputs)
	return en_why_listening_compare_note_subscriptions(inputs)
});